import script from "./CartItems.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartItems.vue?vue&type=script&lang=ts&setup=true"

import "./CartItems.vue?vue&type=style&index=0&id=69819e6e&lang=scss"

const __exports__ = script;

export default __exports__